import React, { useEffect, useState } from 'react';
import { Breadcrumb, Form, Input, Card, Row, Col, Switch, Typography, Space } from 'antd';
import { HomeOutlined, BulbOutlined, BulbFilled } from '@ant-design/icons';
import { Button } from 'antd';
import UpdateMessages from './modals/updateMessage';
import { ToastContainer } from 'react-toastify';
import { getMessages } from '../../../services/messages/messagesApi';

const { TextArea } = Input;
const { Title, Text } = Typography;

const Messages = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState(null);
    const [venteMessages, setVenteMessages] = useState([]);
    const [achatMessages, setAchatMessages] = useState([]);


   

    const fetchMessages = async () => {
        const responseVente = await getMessages('apresvente');
        const responseAchat = await getMessages('apresachat');
        const messagesVente = responseVente.data;
        const messagesAchat = responseAchat.data;

        setVenteMessages(messagesVente);
        setAchatMessages(messagesAchat);
    }

    useEffect(() => {
        fetchMessages();
    }, []);

    const onUpdate = async () => {
        fetchMessages();
    }

    const handleUpdate = (message) => {
        setMessage(message);
        setIsOpen(true);
    }

    return (
        <>
            <div style={{ 
                padding: '24px',
                backgroundColor: "var(--background-body)",
                minHeight: '100vh',
                color: "var(--primary-color)"
            }}>
                {/* En-tête avec titre et switch mode sombre/clair */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '24px',
                    flexWrap: 'wrap',
                    gap: '16px'
                }}>
                    <div>
                        <div style={{ marginBottom: '8px' }}>
                            <i className="bx bx-tag me-2" style={{ color: "var(--primary-color3)" }} />
                            <Title level={2} style={{ 
                                color: "var(--primary-color3)", 
                                margin: 0, 
                                display: 'inline' 
                            }}>
                                Messages
                            </Title>
                        </div>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <HomeOutlined style={{ color: "var(--primary-color)" }} />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item style={{ color: "var(--primary-color3)" }}>
                                Messages
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    
                  
                </div>

                {/* Section Messages Vente */}
                <Card
                    title={
                        <Title level={4} style={{ 
                            color: "var(--primary-color3)",
                            margin: 0
                        }}>
                            📧 Messages Vente
                        </Title>
                    }
                    style={{ 
                        marginBottom: '24px',
                        backgroundColor: "var(--background-body)",
                        border: "1px solid var(--primary-color6)",
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}
                    bodyStyle={{ padding: '16px' }}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <TextArea
                                value={venteMessages.message || ''}
                                disabled
                                rows={6}
                                style={{
                                    backgroundColor: "var(--background-body)",
                                    color: "var(--primary-color)",
                                    border: "1px solid var(--primary-color6)",
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    resize: 'none'
                                }}
                            />
                        </Col>
                        <Col span={24}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button 
                                    type="primary" 
                                    onClick={() => handleUpdate(venteMessages)}
                                    style={{ 
                                        backgroundColor: "var(--primary-color3)",
                                        borderColor: "var(--primary-color3)"
                                    }}
                                >
                                    ✏️ Modifier
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Section Messages Achat */}
                <Card
                    title={
                        <Title level={4} style={{ 
                            color: "var(--primary-color3)",
                            margin: 0
                        }}>
                            💰 Messages Achat
                        </Title>
                    }
                    style={{ 
                        marginBottom: '24px',
                        backgroundColor: "var(--background-body)",
                        border: "1px solid var(--primary-color6)",
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}
                    bodyStyle={{ padding: '16px' }}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <TextArea
                                value={achatMessages.message || ''}
                                disabled
                                rows={6}
                                style={{
                                    backgroundColor: "var(--background-body)",
                                    color: "var(--primary-color)",
                                    border: "1px solid var(--primary-color6)",
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    resize: 'none'
                                }}
                            />
                        </Col>
                        <Col span={24}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button 
                                    type="primary" 
                                    onClick={() => handleUpdate(achatMessages)}
                                    style={{ 
                                        backgroundColor: "var(--primary-color3)",
                                        borderColor: "var(--primary-color3)"
                                    }}
                                >
                                    ✏️ Modifier
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>

                {/* Indicateur d'état vide */}
                {(!venteMessages.message && !achatMessages.message) && (
                    <Card
                        style={{ 
                            backgroundColor: "var(--background-body)",
                            border: "1px solid var(--primary-color6)",
                            textAlign: 'center'
                        }}
                    >
                        <Text style={{ color: "var(--primary-color)", fontSize: '16px' }}>
                            📝 Aucun message configuré. Cliquez sur "Modifier" pour ajouter vos messages.
                        </Text>
                    </Card>
                )}
            </div>

            <ToastContainer draggable />
            <UpdateMessages 
                isOpen={isOpen} 
                onClose={() => setIsOpen(false)} 
                message={message} 
                onUpdate={onUpdate} 
            />
        </>
    );
};

export default Messages;